import { render } from "./EditVehicleModal2.vue?vue&type=template&id=f87479c6&scoped=true"
import script from "./EditVehicleModal2.vue?vue&type=script&lang=js"
export * from "./EditVehicleModal2.vue?vue&type=script&lang=js"

import "./EditVehicleModal2.vue?vue&type=style&index=0&id=f87479c6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f87479c6"]])

export default __exports__